var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoPlaceholder = function SvgVideoPlaceholder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 53,
    fill: "none",
    viewBox: "0 0 50 53",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEAE6",
    stroke: "#000",
    strokeWidth: 2.5,
    d: "M7 51h38a3 3 0 0 0 3-3V23.5H4V48a3 3 0 0 0 3 3ZM38.096 3.038l2.898-.777a3 3 0 0 1 3.674 2.122l1.941 7.244-12.557 3.365m4.044-11.954-4.044 11.954m4.044-11.954L26.505 6.144m7.547 8.848L22.46 18.098m4.044-11.954L22.46 18.098m4.044-11.954L14.43 9.379m8.03 8.719-12.074 3.235M14.43 9.379 4.288 12.097a3 3 0 0 0-2.12 3.674l1.94 7.244 6.279-1.682M14.43 9.379l-4.044 11.954"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.5,
    d: "m20 31.5 12 5.75L20 43z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoPlaceholder);
export default ForwardRef;